import React, { useContext } from 'react';
import clsx from 'clsx';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Hidden,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Grid,
} from '@material-ui/core'

import RewardContext from '../../context/reward-context';
import useStyles from '../../styles/components/rewards/stylesRewardShop';
import { Coin } from '../shared/component';

const RewardConfirmationDialog = () => {
    const { rewardContext, redeemRewardItems } = useContext(RewardContext);
    const [open, setOpen] = React.useState(false);
    const classes = useStyles()

    const handleClickOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    const handleOk = () => {
        redeemRewardItems();
        handleClose();
    };

    return (
        <>
            {rewardContext &&
                <div>
                    <Grid
                        onClick={handleClickOpen}
                        classes={{ root: classes.containerButtonRedeem }}
                        className={clsx(!rewardContext.redeemButtonStatus && classes.buttonDisabled)}
                        container
                        justify="center"
                        alignContent="center"
                    >
                        <Grid
                            classes={{ root: classes.containerButtonContent }}
                            item xs={6}
                            container
                            justify="center"
                            alignContent="center"
                        >
                            Redeem
                        </Grid>
                        <Grid
                            classes={{ root: classes.containerButtonCoin }}
                            item xs={6}
                            container
                            justify="center"
                            alignContent="center"
                        >
                            <Hidden smDown>
                                <Coin
                                    size="medium"
                                    coin={rewardContext.totalCoins}
                                    color={'non-border'}
                                />
                            </Hidden>
                            <Hidden mdUp>
                                <Coin
                                    size="small"
                                    coin={rewardContext.totalCoins}
                                    color={'non-border'}
                                />
                            </Hidden>
                        </Grid>
                    </Grid>

                    <Dialog
                        open={open}
                        onClose={handleClose}
                        classes={{
                            root: classes.rootDialogConfirm,
                            paper: classes.paperDialogConfirm,
                        }}
                    >
                        <DialogTitle disableTypography={true} classes={{ root: classes.rootDialogConfirmTitle }}>
                            Rewards Redemption Confirmation
                        </DialogTitle>
                        <DialogContent classes={{ root: classes.rootDialogConfirmContent }}>
                            <div className={classes.dialogContentNote}>
                                Note: Rewards are subjected to availability
                            </div>

                            <div className={classes.dialogContentConfirm}>Do you want to send the following reward(s) redemption request?</div>

                        </DialogContent>
                        <TableContainer classes={{ root: classes.rootTableContainer }}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell classes={{ root: classes.rootTableCell, head: classes.headTableCell }} align="left">No.</TableCell>
                                        <TableCell classes={{ root: classes.rootTableCell, head: classes.headTableCell }} align="center">Description</TableCell>
                                        <TableCell classes={{ root: classes.rootTableCell, head: classes.headTableCell }} align="center">Quantity</TableCell>
                                        <TableCell classes={{ root: classes.rootTableCell, head: classes.headTableCell }} align="center">Brand</TableCell>
                                        <TableCell classes={{ root: classes.rootTableCell, head: classes.headTableCell }} align="center">Coins Deducted</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rewardContext.redeemRewardItems.length > 0 &&
                                        (rewardContext.redeemRewardItems).map((itemRedeem, index) => (
                                            <TableRow key={index}>
                                                <TableCell classes={{ root: classes.rootTableCell }} align="left">{index + 1}</TableCell>
                                                <TableCell classes={{ root: classes.rootTableCell }} align="center">{itemRedeem.description}</TableCell>
                                                <TableCell classes={{ root: classes.rootTableCell }} align="center">{itemRedeem.quantity}</TableCell>
                                                <TableCell classes={{ root: classes.rootTableCell }} align="center">{itemRedeem.voucherCategoryName}</TableCell>
                                                <TableCell classes={{ root: classes.rootTableCell }} align="center">
                                                    <Hidden smDown>
                                                        <Coin size="medium" coin={`- ${itemRedeem.coins * itemRedeem.quantity}`} color="substract" />
                                                    </Hidden>
                                                    <Hidden mdUp>
                                                        <Coin size="small" coin={`- ${itemRedeem.coins * itemRedeem.quantity}`} color="substract" />
                                                    </Hidden>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <DialogActions classes={{ root: classes.rootDialogActions }}>
                            <Button onClick={handleClose} className={clsx(classes.buttonDialogConfirm, classes.buttonCancle)}>
                                Cancel
                            </Button>
                            <Button onClick={handleOk} className={clsx(classes.buttonDialogConfirm, classes.buttonYes)}>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>

            }
        </>
    );
};

export { RewardConfirmationDialog as default }